export default "__VITE_ASSET__ee673065__"